import * as Yup from 'yup'

export const MILITARY_TIME_REGEX = /^([01]\d|2[0-3])[0-5]\d$/

export function militaryTimeSchema(fieldLabel = 'Time') {
  return Yup.string()
    .required(`${fieldLabel} required`)
    .test('military-format', `${fieldLabel} must be HHMM (0000–2359)`, value =>
      Boolean(value && MILITARY_TIME_REGEX.test(value))
    )
}
